// removed by extract-text-webpack-plugin
module.exports = {"quote":"src-pages----page-module---quote---2V7vH","quoteSign":"src-pages----page-module---quoteSign---LVBeu"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/page.module.css
// module id = 287
// module chunks = 227956834199198